export function getMotifLibelleByCode(code: number): string {
    const motifsMap = new Map(PrescriptionModificationMotif);
    if (motifsMap.has(code)) {
        return motifsMap.get(code);
    } else {
        return 'Motif inconnu';
    }
}

export function getSousMotifLibelleByCode(code: number): string {
    const sousMotifsMap = new Map(PrescriptionModificationSousMotif);
    if (sousMotifsMap.has(code)) {
        return sousMotifsMap.get(code);
    } else {
        return '(Aucun sous-motif.)';
    }
}

const PrescriptionModificationMotif: Array<[number, string]> = [
    [ 1, "Adaptation de la posologie" ],
    [ 2, "Adaptation de la forme d’administration" ],
    [ 3, "Modification de la DCI" ],
    [ 4, "Adaptation de la durée de traitement" ],
    [ 5, "Risque de iatrogénie" ],
    [ 6, "Arrêt ou refus de délivrer" ],
    [ 7, "Adaptation de la quantité délivrée" ],
    [ 8, "Renouvellement" ],
    [ 9, "Intégration d’une ligne de prescription manuscrite" ],
    [ 10, "Non substitué" ],
    [ 11, "Renouvellement d’optique" ],
    [ 21, "Contre-indication" ],
    [ 22, "Non-conformité aux référentiels" ],
    [ 23, "Problème de posologie" ],
    [ 24, "Interaction médicamenteuse" ],
    [ 25, "Effet indésirable" ],
    [ 26, "Oubli de prescription" ],
    [ 27, "Non disponibilité de la spécialité" ],
    [ 28, "Traitement non reçu" ],
    [ 29, "Prescription d’un médicament non justifié ou pour une durée non justifiée" ],
    [ 30, "Redondance" ],
    [ 31, "Prescription non conforme" ],
    [ 32, "Suspicion de Pharmacodépendance" ],
    [ 33, "Monitorage à suivre" ],
    [ 34, "Non substitué par le pharmacien" ],
    [ 35, "Renouvellement" ],
    [ 99, "Autre" ],
]

const PrescriptionModificationSousMotif: Array<[number, string]> = [
    [ 11, "Sur le dosage" ],
    [ 12, "Sur l'unité de prise" ],
    [ 13, "Par rapport au poids, l'âge ou le sexe" ],
    [ 0, "(Aucun sous-motif.)" ],
    [ 31, "Rupture de stock" ],
    [ 32, "Connaissance d’une contre indication" ],
    [ 33, "Connaissance d’une allergie ou d’une intolérance" ],
    [ 41, "Excessive" ],
    [ 42, "Insuffisante" ],
    [ 51, "Existence d’interactions médicamenteuses" ],
    [ 52, "Existence de redondance d'une même molécule" ],
    [ 53, "Suite à consultation DP" ],
    [ 61, "Refus du pharmacien car prescripteur non autorisé" ],
    [ 62, "Refus du patient car en dispose déjà" ],
    [ 63, "Refus du patient car montant de remboursement trop faible" ],
    [ 64, "Non délivré car à ne prendre qu’en cas d’aggravation" ],
    [ 71, "Aberrante" ],
    [ 72, "Non réglementaire" ],
    [ 81, "Exceptionnel" ],
    [ 82, "Réglementaire" ],
    [ 91, "Ajouts manuscrits par le prescripteur" ],
    [ 101, "Non substituable MTE-PH" ],
    [ 111, "Optique/renouvellement à l’identique" ],
    [ 112, "Optique/renouvellement avec adaptation" ],
    [ 1, "Adaptation de la posologie d’un médicament à marge thérapeutique étroite" ],
    [ 2, "Adaptation de la posologie d’un médicament par ajustement des doses" ],
    [ 3, "Allongement d'une durée de traitement" ],
    [ 10, "Choix d'une voix d'administration plus adaptée au patient" ],
    [ 20, "Répartition des prises" ],
    [ 21, "Conseils de prise" ],
    [ 22, "Précisions des modalités d’administration" ],
    [ 23, "Conformité de l’ordonnance" ],
    [ 30, "Suivi thérapeutique" ],
    [ 40, "Ajout (prescription nouvelle)" ],
    [ 43, "Intégration d’une ligne manuscrite" ],
    [ 50, "Changement de médicament ou mise en place d'une alternative thérapeutique" ],
    [ 60, "Non substituable MTE-PH" ],
    [ 70, "Arrêt ou refus de délivrer" ],
    [ 73, "Refus du patient" ],
    [ 80, "Situations particulières de renouvellement exceptionnel ou réglementaire" ],
    [ 83, "Renouvellement d’optique" ],
    [ 99, "Autre" ],
];


































































































































